import { Alert, Box } from "@mui/material";
import { useEffect, useState } from "react";
import { getSendingSuspensions, type SendingSuspensions } from "../api/userprofile";
import { formatOfficeDateTime } from "../utils/date-formatting";
import { SnoozeButton, useBannerSnoozed } from "./banner-snooze";

/**
 * App-wide banner listing ALL currently-paused senders (e.g. after a Microsoft 5.1.8
 * outbound block). Shown to admin + staff so they can act — e.g. unblock the mailbox
 * in the provider portal. The backend returns an empty list for non-staff viewers.
 */
export const SendingSuspensionBanner = () => {
	const [data, setData] = useState<SendingSuspensions | null>(null);

	useEffect(() => {
		let mounted = true;
		const load = () => {
			getSendingSuspensions()
				.then((d) => {
					if (mounted) setData(d);
				})
				.catch(() => {});
		};
		load();
		const id = window.setInterval(load, 60000);
		return () => {
			mounted = false;
			window.clearInterval(id);
		};
	}, []);

	// Per set of paused mailboxes: one more paused mailbox shows the banner again.
	const bannerKey = `sending-suspension:${(data?.paused ?? [])
		.map((u) => u.user_id)
		.sort((a, b) => a - b)
		.join(",")}`;
	const snoozed = useBannerSnoozed(bannerKey);

	if (!data || data.paused.length === 0 || snoozed) return null;

	return (
		<Box data-component="sending-suspension-banner">
			<Alert
				severity="error"
				data-component="sending-suspension-list"
				action={<SnoozeButton bannerKey={bannerKey} />}
			>
				Artemis paused sending for {data.paused.length} mailbox
				{data.paused.length > 1 ? "es" : ""} after the provider bounced its mail
				as an outbound block — unblock in the provider portal:{" "}
				{data.paused
					.map(
						(u) =>
							`${u.email} until ${formatOfficeDateTime(u.until)} (${u.reason})`
					)
					.join("; ")}
			</Alert>
		</Box>
	);
};
